import { useEffect, useState } from 'react';

import type React from 'react';

export const ScrollHeader: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const header = document.querySelector('header.wcag-header');
    if (!header) return undefined;

    const handleScroll = () => {
      const scrollPosition = window.scrollY || document.documentElement.scrollTop;

      const jobHeaderSection = document.querySelector('#job-header-heading')?.closest('section');
      if (jobHeaderSection) {
        const sectionRect = jobHeaderSection.getBoundingClientRect();
        const sectionBottom = scrollPosition + sectionRect.bottom;
        const headerHeight = header.getBoundingClientRect().height;

        setIsScrolled(sectionBottom < scrollPosition + headerHeight);
      } else {
        setIsScrolled(scrollPosition > 300);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const header = document.querySelector('header.wcag-header');
    if (!header) return;

    const jobTitle = header.getAttribute('data-job-title');
    const jobTitleElement = header.querySelector('.wcag-job-title');

    if (isScrolled) {
      header.classList.add('scrolled');
      if (jobTitleElement && jobTitle) {
        jobTitleElement.textContent = jobTitle;
      }
    } else {
      header.classList.remove('scrolled');
    }
  }, [isScrolled]);

  return null;
};

export default ScrollHeader;
